import { render, staticRenderFns } from "./eat-in-menu-group.vue?vue&type=template&id=93711c18&scoped=true"
import script from "./eat-in-menu-group.vue?vue&type=script&lang=js"
export * from "./eat-in-menu-group.vue?vue&type=script&lang=js"
import style0 from "./eat-in-menu-group.vue?vue&type=style&index=0&id=93711c18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93711c18",
  null
  
)

export default component.exports